import React from 'react'
import { List, Message, Transition } from 'semantic-ui-react'
import { arrayOf, object, oneOf } from 'prop-types'
import { translate } from 'react-i18next'
import { connectToast } from './ConnectMessages'
import { messageStore } from './Toast'
import css from './DashboardMessage.css'

class DashboardMessage extends React.PureComponent {
  static propTypes = {
    messages: arrayOf(object).isRequired,
    position: oneOf(['bottom-right',
      'bottom-left',
      'top-right',
      'top-left',
      'center'])
  };
  static defaultProps = {
    position: 'center'
  };

  render() {
    let { t, messages, position } = this.props;
    return (
      <Transition.Group as={List} className={css[position]}>
        {messages.map((m, i) => (<Message floating compact content={t(m.message, m.options.params)} key={i} {...m.options} />))}
      </Transition.Group>
    )
  }
}
export default connectToast(messageStore)(translate()(DashboardMessage));
export { DashboardMessage };
